import { render, staticRenderFns } from "./LightPackageShipmentForm.vue?vue&type=template&id=0076c570&scoped=true"
import script from "./LightPackageShipmentForm.vue?vue&type=script&lang=js"
export * from "./LightPackageShipmentForm.vue?vue&type=script&lang=js"
import style0 from "./LightPackageShipmentForm.vue?vue&type=style&index=0&id=0076c570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0076c570",
  null
  
)

export default component.exports